/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";

export const FlagsPermissionDispatch = {
  permission_dispatch_enable: new Rox.Flag(false),
  permission_dispatch_detail_view: new Rox.Flag(false),
  permission_dispatch_update_view: new Rox.Flag(false)
};

export function initFlagsPermissionDispatch() {
  Rox.register("featureDispatch", FlagsPermissionDispatch);
}
